export const REFERENCE_LABEL_STYLES = {
    color: "#84acbc",
    fontFamily: "Lato, sans-serif",
    fontSize: "28px",
    fontWeight: "bolder",
    textTransform: "uppercase",
    opacity: 0.18,
};
